import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { formatMoney } from '@belong/common';

const MoneyRange = /*#__PURE__*/React.forwardRef(function MoneyRange({
  lower,
  upper,
  format = 'DOLLARS_WITH_CENTS',
  ...rest
}, ref) {
  if (Math.round(Number(lower)) === Math.round(Number(upper))) {
    return jsx("span", {
      ref: ref,
      ...rest,
      children: formatMoney(lower, format)
    });
  }
  return jsxs("div", {
    className: "flex items-center gap-2xs",
    children: [jsx("span", {
      ref: ref,
      ...rest,
      children: formatMoney(lower, format)
    }), jsx("span", {
      ...rest,
      children: "-"
    }), jsx("span", {
      ref: ref,
      ...rest,
      children: formatMoney(upper, format)
    })]
  });
});

export { MoneyRange };
